import store from '@/store/store'

export default function (score) {
  return (score * store.state.gameplay.maximumScore).toFixed().toString()
}
